import { Component, Prop, Vue } from 'vue-property-decorator'
import ConfigurationRelationships
    from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { ConfigurationPersonnelResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'
import {
    ConfigurationAutomationPersonnelEntitiesAssociationModalSampleTypeAssignmentFormState,
    initialConfigurationAutomationPersonnelEntitiesAssociationModalSampleTypeAssignmentFormState
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-sample-type-assignment-form/configuration-automation-personnel-entities-association-modal-sample-type-assignment-form.model'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { commonSampleTypeService } from '@/api/services/common/sample-type/common-sample-type.service'
import {
    ConfigurationPersonnelSampleTypeAssignmentCreateRequest,
    ConfigurationPersonnelSampleTypeAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-sample-type-assignment/configuration-personnel-sample-type-assignment.dto'
import { configurationPersonnelSampleTypeAssignmentService } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-sample-type-assignment/configuration-personnel-sample-type-assignment.service'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class ConfigurationAutomationPersonnelEntitiesAssociationModalSampleTypeAssignmentForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly personnel!: ConfigurationPersonnelResponse

    state: ConfigurationAutomationPersonnelEntitiesAssociationModalSampleTypeAssignmentFormState
    constructor() {
        super()
        this.state = initialConfigurationAutomationPersonnelEntitiesAssociationModalSampleTypeAssignmentFormState()
    }

    private async _loadSampleTypes(): Promise<void> {
        this.state.sampleTypes = await this._getSampleTypes()
    }

    private async _loadPersonnelSampleTypeAssignments(): Promise<void> {
        this.state.personnelSampleTypeAssignments = await this._getPersonnelSampleTypeAssignments()
    }

    async mounted() {
        await this._loadSampleTypes()
        await this._loadPersonnelSampleTypeAssignments()
    }

    /// SERVICES CALLS ///

    private async _getSampleTypes(): Promise<CommonSampleTypeResponse[]> {
        const response = await this.$_toCallUnique(commonSampleTypeService.getSampleTypes())
        if (response) {
            return response
        }
        return []
    }

    private async _getPersonnelSampleTypeAssignments(): Promise<ConfigurationPersonnelSampleTypeAssignmentResponse[]> {
        const filterModel: CommonFilterModel = {
            'personnel.id': GridUtils.getNumberFilterModel('equals', this.personnel.id)
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationPersonnelSampleTypeAssignmentService.paginator(filterModel, params, this.state.laboratoryId))
        if (response) {
            return response.content
        }
        return []
    }

    private async _createPersonnelSampleTypeAssignment(createRequest: ConfigurationPersonnelSampleTypeAssignmentCreateRequest): Promise<ConfigurationPersonnelSampleTypeAssignmentResponse | null> {
        const response = await this.$_toCallUnique(configurationPersonnelSampleTypeAssignmentService.create(this.state.laboratoryId, createRequest))
        if (response) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.created'))
            return response
        }
        return null
    }

    private async _deletePersonnelSampleTypeAssignment(personnelSampleTypeAssignmentId: number): Promise<void> {
        if (personnelSampleTypeAssignmentId) {
            await this.$_toCallUnique(configurationPersonnelSampleTypeAssignmentService.delete(personnelSampleTypeAssignmentId, this.state.laboratoryId))
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
        }
    }

    /// FORM OPERATIONS ///

    async createOperation(sampleType: CommonSampleTypeResponse): Promise<void> {
        if (sampleType) {
            const createRequest: ConfigurationPersonnelSampleTypeAssignmentCreateRequest = {
                personnelId: this.personnel.id,
                sampleTypeId: sampleType.id
            }
            if (await this._createPersonnelSampleTypeAssignment(createRequest)) {
                await this._loadPersonnelSampleTypeAssignments()
            }
        }
    }

    async deleteOperation(personnelSampleTypeAssignment: ConfigurationPersonnelSampleTypeAssignmentResponse): Promise<void> {
        if (personnelSampleTypeAssignment) {
            await this._deletePersonnelSampleTypeAssignment(personnelSampleTypeAssignment.id)
            await this._loadPersonnelSampleTypeAssignments()
        }
    }
}
